import { Component, Input } from '@angular/core';
import { Milestone } from '@freelancer/datastore';
import { ModalRef } from '@freelancer/ui';
import { ButtonColor } from '@freelancer/ui/button';
import {
  MilestoneConfirmModalResponse,
  MilestoneConfirmModalType,
} from './milestone-confirm-modal.types';

@Component({
  template: `
    <div class="MainBody">
      <fl-bit *ngIf="this.confirmType === MilestoneConfirmModalType.REQUEST_CANCEL">
        Are you sure you wanna request the freelancer to cancel this milestone?
      </fl-bit>

      <fl-bit *ngIf="this.confirmType === MilestoneConfirmModalType.CANCEL">
        Are you sure you want to cancel this milestone?
      </fl-bit>

      <fl-bit *ngIf="this.confirmType === MilestoneConfirmModalType.REQUEST_RELEASE">
        Are you sure you want to request the employer to release?
      </fl-bit>

      <fl-bit *ngIf="this.confirmType === MilestoneConfirmModalType.RELEASE">
        Are you sure you want to release this milestone to the freelancer?
      </fl-bit>
    </div>

    <div class="ActionContainer">
      <fl-button class="ActionButton"
        [color]="ButtonColor.DEFAULT"
        (click)="onCancel()"
      >
        Close
      </fl-button>

      <fl-button class="ActionButton"
        [color]="ButtonColor.SECONDARY"
        (click)="onConfirm()"
      >
        Confirm
      </fl-button>
    </div>
  `,
})
export class MilestoneConfirmModalComponent {
  ButtonColor = ButtonColor;
  MilestoneConfirmModalType = MilestoneConfirmModalType;

  @Input() milestone: Milestone;
  @Input() confirmType: MilestoneConfirmModalType;

  constructor(private modalRef: ModalRef<MilestoneConfirmModalComponent>) {}

  onConfirm() {
    this.modalRef.close(MilestoneConfirmModalResponse.SUCCESS);
  }

  onCancel() {
    this.modalRef.close(MilestoneConfirmModalResponse.FAILURE);
  }
}
